<template>
    <div id="newsletter" class="hero" :class="[wor ? 'wor' : 'row']">
        <div class="container" style="min-height: 14rem;">


            <div id="news">

                <p :class="[wor ? 'newstitle-wor' : 'newstitle-row']">NEWSLETTER</p>


                <p class="f-newsletter-title" :class="[wor ? 'wor' : 'bow']">Subscreva e receba as nossas novidades!</p>


                <div class="f-newsletter-field field has-addons">
                    <v-app v-if="!subSuccess" id="vapp" style="min-height: 0 !important; max-height:0 !important; min-width:25vw !important;">
                        <v-form class="pt0">
                            <v-text-field
                                    class="pt0"
                                    :color="wor ? 'white' : 'deep-purple darken-4'"
                                    v-model="email"
                                    :placeholder="focused ? '' : 'Coloque o seu e-mail'"
                                    @change="submitted=false"
                                    @focus="focused = true"
                                    @blur="focused = false"
                            ></v-text-field>
                            <p class="mailerror" :class="[wor ? 'wor' : 'row']" v-if="submitted && !email">Campo obrigatório</p>
                            <p class="mailerror" :class="[wor ? 'wor' : 'row']" v-if="email && email.length>0 && !email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)">E-mail inválido</p>
                        </v-form>
                    </v-app>
                    <div id="sub-success" v-else>
                        Assinatura realizada com sucesso!
                    </div>

                    <a v-if="!subSuccess" class="" @click="submitted=true; addSubscriber()">
                        <transition>
                            <i v-if="!loading" class="fa fa-paper-plane fa-fw" :class="[wor ? 'wor' : 'row']" style="cursor:pointer;"></i>
                            <i v-else class="fa fa-circle-o-notch fa-spin fa-fw" :class="[wor ? 'wor' : 'row']"></i>
                        </transition>
                    </a>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
import { notificationMixin } from "../plugins/notificationMixin";
import { apiUrl } from "../vars";

export default {
  mixins: [notificationMixin],
  props: ["wor"],
  data: () => ({
    subSuccess: false,
    focused: false,
    email: null,
    submitted: false,
    loading: false
  }),

  methods: {
    addSubscriber() {
      this.loading = true;
      let that = this;
      axios
        .post(apiUrl + "api/newsletter", { email: this.email })
        .then(response => {
          if (response.data.hasOwnProperty("status")) {
            if ((response.data.status = "success")) {
              that.subSuccess = true;
            }
            if ((response.data.status = "success")) {
              that.error = "Erro ao confirmar a assinatura.";
            }
            that.loading = false;
          }
        })
        .catch(error => {
          console.error(error);
          that.loading = false;
        });
    }
  }
};
</script>
<style scoped>
#news {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.newstitle-row {
  border: solid 1px #e90054;
  padding: 0.25rem 1rem;
  color: #e90054;
}

.newstitle-wor {
  border: solid 1px #ffffff;
  padding: 0.25rem 1rem;
  color: #ffffff;
}

#sub-success {
  padding: 0.15rem 0.75rem;
}

.mailerror {
  //color: #e90054 !important;
  font-size: 0.75rem;
  margin: -1rem 0 0;
  padding: 0;
}

.input-group.input-group--error .input-group__messages {
  //color: #e90054 !important;
}

.application--wrap {
  min-height: 0 !important;
}

.column {
  padding: 1rem 2rem;
}

.button {
  padding: 1em 2rem;
  height: 4rem;
  border-radius: 0 5px 5px 0;
  background-color: #2d3256;
}

.hero {
  padding: 1em 0 1rem;
}

.f-newsletter-field {
  position: relative;
}

.f-newsletter-title {
  font-weight: 900;
  font-size: 1.75rem;
  line-height: 1.1;
  margin: 1.5rem 0;
}

.f-newsletter-subtitle {
  font-weight: 300;
  font-size: 1.2rem;
  line-height: 1.1;
}

.row {
  color: #e90054 !important;
  background-color: white;
}

.bow {
  color: #424242 !important;
  background-color: white;
}

.wor {
  color: white !important;
  background-color: #e90054;
}
</style>



// WEBPACK FOOTER //
// src/components/Newsletter.vue